import orderBy from 'lodash/orderBy';

import store from 'Redux/store';
import { itemsToApplyVoucherTo } from 'Reselects/cartcalc';

const VOUCHER_UPSELL = 'frontend/vouchers/VOUCHER_UPSELL';
const VOUCHER_SPEND_MORE = 'frontend/vouchers/VOUCHER_SPEND_MORE';

export function findValidVoucher(product, vouchers) {
  if (!product) {
    return null;
  }

  if ((product.slug || '').includes('warhammer-40-000-darktide')) return null;

  const valid = vouchers.filter((voucher) => {
    const { voucherApplyArray } = itemsToApplyVoucherTo({
      voucher,
      pickAndMixAll: store.getState().pickAndMix.all,
      cartItems: [product],
    });

    if (voucherApplyArray.filter(prod => prod._id === product._id).length) {
      return true;
    }

    return false;
  });
  if (valid.length) {
    return orderBy(valid, ['percent']);
  }
  return false;
}

export function setVoucherUpsell(qualifed) {
  store.dispatch({ type: VOUCHER_UPSELL, payload: qualifed });
}

export function setUpSpendMore(qualifed) {
  store.dispatch({ type: VOUCHER_SPEND_MORE, payload: qualifed });
}
